import { render, staticRenderFns } from "./headImg.vue?vue&type=template&id=785a69a3&scoped=true&"
import script from "./headImg.vue?vue&type=script&lang=js&"
export * from "./headImg.vue?vue&type=script&lang=js&"
import style0 from "./headImg.vue?vue&type=style&index=0&lang=css&"
import style1 from "./headImg.vue?vue&type=style&index=1&id=785a69a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785a69a3",
  null
  
)

export default component.exports